<template>
  <div>
    <!-- slider-section -->
    <Sliderrtl />
    <!-- end slider section -->

    <!-- about section-->
    <Aboutrtl />
    <!-- end about section  -->

    <!-- Feature section -->
    <Featurertl />
    <!-- end Feature section -->

    <!-- work section -->
    <Workrtl />
    <!-- end work section -->

    <!--screenshots section-->
    <Screenshotsrtl />
    <!--end screenshots section-->

    <!-- team section-->
    <Teamrtl />
    <!-- end team section-->

    <!-- package section -->
    <Packagertl />
    <!-- end package section -->

    <!--testimonail page -->
    <Testimonialrtl />
    <!-- end testimonial section -->

    <!-- FAQ section -->
    <FAQrtl />
    <!-- end FAQ section -->

    <!-- news section-->
    <Blogrtl />
    <!-- end news section-->

    <!-- download section -->
    <DownloadRTL />
    <!-- end download section -->

    <!-- footer-section -->
    <Footerrtl />
    <!-- end footer section -->

    <!-- subscribe section -->
    <Subscribertl />
    <!-- end subscribe section -->

    <!-- copy-right-section -->
    <Copyrightrtl />
    <!--end copy right section-->

    <!--[if lt IE 9]>
      <div class="ie-warning">
          <h1>تحذير!!</h1>
          <p>أنت تستخدم إصدارًا قديمًا من متصفح الانترنت ، الرجاء الترقية إلى أي من متصفحات الويب التالية للدخول إلى موقع
              الويب هذا.</p>
          <div class="iew-container">
              <ul class="iew-download">
                  <li>
                      <a href="http://www.google.com/chrome/">
                          <img src="../../assets/images/browsers/chrome.png" alt="">
                          <div>Chrome</div>
                      </a>
                  </li>
                  <li>
                      <a href="https://www.mozilla.org/en-US/firefox/new/">
                          <img src="../../assets/images/browsers/firefox.png" alt="">
                          <div>Firefox</div>
                      </a>
                  </li>
                  <li>
                      <a href="http://www.opera.com">
                          <img src="../../assets/images/browsers/opera.png" alt="">
                          <div>Opera</div>
                      </a>
                  </li>
                  <li>
                      <a href="https://www.apple.com/safari/">
                          <img src="../../assets/images/browsers/safari.png" alt="">
                          <div>Safari</div>
                      </a>
                  </li>
                  <li>
                      <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">
                          <img src="../../assets/images/browsers/ie.png" alt="">
                          <div>IE (9 & above)</div>
                      </a>
                  </li>
              </ul>
          </div>
          <p>آسف للإزعاج!</p>
      </div>
      <![endif]-->
  </div>
</template>
<script>
import Sliderrtl from "@/rtl/components/slider.vue";
import Aboutrtl from "@/rtl/components/about.vue";
import Featurertl from "@/rtl/components/feature.vue";
import Workrtl from "@/rtl/components/work.vue";
import Screenshotsrtl from "@/rtl/components/screenshots.vue";
import Teamrtl from "@/rtl/components/team.vue";
import Packagertl from "@/rtl/components/package.vue";
import Testimonialrtl from "@/rtl/components/testimonial.vue";
import FAQrtl from "@/rtl/components/faq.vue";
import Downloadrtl from "@/rtl/components/download.vue";
import Footerrtl from "@/rtl/components/footer.vue";
import Subscribertl from "@/rtl/components/subscribe.vue";
import Copyrightrtl from "@/rtl/components/copy_right.vue";
import Blogrtl from "@/rtl/components/blog.vue";
export default {
  name: "Index",
  data() {
    return {
      screenshotPosition: 0,
      windowPositions: {
        sliderPosition: 0,
        aboutPosition: 0,
        featurePosition: 0,
        workPosition: 0,
        screenshotsPosition: 0,
        teamPosition: 0,
        packagePosition: 0,
        testimonialPosition: 0,
        faqPosition: 0,
        downloadPosition: 0,
        footerPosition: 0,
        subscribePosition: 0,
        copyrightPosition: 0,
        blogPosition: 0,
      },
    };
  },
  mounted: function () {
    document.body.classList.remove("inner-page");
  },
  components: {
    Sliderrtl,
    Aboutrtl,
    Featurertl,
    Workrtl,
    Screenshotsrtl,
    Teamrtl,
    Packagertl,
    Blogrtl,
    Testimonialrtl,
    FAQrtl,
    Downloadrtl,
    Footerrtl,
    Subscribertl,
    Copyrightrtl,
  },
};
</script>
